<template>
  <div class="page-column">
    <div class="PhysicalFitnessRank">
      <MatchHeader />
      <MatchInfo />
      <MatchMenu />
      <RankDetail />
      <Footer />
    </div>
  </div>
</template>

<script>
import MatchHeader from '@/views/layout/MatchHeader.vue'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import Footer from '@/views/layout/Footer.vue'
import RankDetail from './components/RankDetail.vue'
export default {
  name: 'PhysicalFitnessRank',
  props: {},
  components: {
    MatchHeader,
    MatchInfo,
    MatchMenu,
    RankDetail,
    Footer,
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {},
  watch: {},
  created() {
    window.scrollTo(0, 0)
  },
}
</script>

<style scoped lang="scss">
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/PhysicalFitness/Rank.vue